import type { User } from "@supabase/supabase-js";

// The best human label for a Supabase auth user: the profile name the sign-up
// flow stored in user_metadata, else the contact it signed in with.
export function getAuthUserDisplayName(
  user: Pick<User, "email" | "phone" | "user_metadata">
): string | null {
  // user_metadata is `{ [key: string]: any }`: narrow each field.
  const metadata: Record<string, unknown> = user.user_metadata ?? {};
  const text = (value: unknown) =>
    typeof value === "string" && value !== "" ? value : null;
  return (
    text(metadata.full_name) ??
    text(metadata.name) ??
    text(user.email) ??
    text(user.phone)
  );
}
